// extracted by mini-css-extract-plugin
export default {"table-container":"drZWdLBkE3Zq9SIyMJXV","table-top-right-field":"VE66reiCypFFee7hdUbX","divider":"oD_i6_r06KQZuZLAa2dn","table-wrapper":"XRhYmDTJRp1orqyhPp27"};